module.exports = __webpack_public_path__ + "img/PL08678.2f2dcf98.png";